module.exports = __webpack_public_path__ + "b6419cfc730342baa41d10249c6cea22.gif";